import { useQuery } from "@tanstack/react-query"
import { getVehicleDailyAuditReport } from "api/vehicleDailyAuditApi"

export const VEHICLE_DAILY_AUDIT_REPORT_QUERY_KEY = "vehicle-daily-audit-report"

export const useVehicleDailyAuditReport = (params = {}, enabled = true) => {
  return useQuery({
    queryKey: [VEHICLE_DAILY_AUDIT_REPORT_QUERY_KEY, params],
    queryFn: () => getVehicleDailyAuditReport(params),
    enabled,
  })
}
